import { render, staticRenderFns } from "./ProductCategoryBreadcrumb.vue?vue&type=template&id=6a928ff1&scoped=true"
import script from "./ProductCategoryBreadcrumb.vue?vue&type=script&lang=js"
export * from "./ProductCategoryBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a928ff1",
  null
  
)

export default component.exports